var _ellipse, _path, _ellipse2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    fill: "none",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.5,
    cy: 52,
    fill: "#fff",
    rx: 8.5,
    ry: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0277BD",
    d: "M120.235 25c-7.775.025-13.165.71-19.68 1.835-19.24 3.35-22.745 10.385-22.745 23.35V70h45v10H54.35c-13.18 0-24.715 6.21-28.37 21.095-4.13 17.085-4.315 27.785 0 45.625C29.255 160.025 36.47 170 49.655 170h18.16v-25.52c0-14.83 13.43-29.48 28.82-29.48h36.18c12.615 0 25-9.31 25-21.885v-42.93c0-12.195-8.795-21.315-21.09-23.36.305-.03-8.78-1.855-16.49-1.825zm-24.92 20c4.105 0 7.5 3.385 7.5 7.51 0 4.165-3.395 7.49-7.5 7.49-4.185 0-7.5-3.32-7.5-7.49 0-4.11 3.315-7.51 7.5-7.51z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.5,
    cy: 188,
    fill: "#fff",
    rx: 8.5,
    ry: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M115.39 215c7.775-.025 13.165-.71 19.68-1.835 19.24-3.35 22.745-10.385 22.745-23.35V170h-45v-10h68.465c13.18 0 24.715-6.21 28.37-21.095 4.13-17.085 4.315-27.785 0-45.625C206.37 79.975 199.155 70 185.97 70h-18.16v25.52c0 14.83-13.43 29.48-28.82 29.48h-36.18c-12.615 0-25 9.31-25 21.885v42.93c0 12.195 8.795 21.315 21.09 23.36-.305.03 8.78 1.855 16.49 1.825zm24.925-20c-4.105 0-7.5-3.385-7.5-7.51 0-4.165 3.395-7.49 7.5-7.49 4.185 0 7.5 3.32 7.5 7.49 0 4.11-3.32 7.51-7.5 7.51z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.fbb5f529520f4008e932e4b7ad2b2591.svg";
export { ForwardRef as ReactComponent };